import Button from "./Button.jsx";
import GenericUtils from "../../lib_react_frontend/utils/GenericUtils";
import InputGroup from "./InputGroup.jsx";
import Modal from "./Modal.jsx";
import React from "react";
import { Table } from "./Table.jsx";

export default class ModalSearch extends React.Component {
  state = {
    pesquisa: "",
    itemSelecionado: null,
    registros: [],
    index: 0,
    filtroAplicado: false,
    qtderegistros: 25,
    range: {
      from: 0,
      to: 25,
    },
  };
  /**
   * Chamado quando o usuário clicar em confirmar.
   */

  onConfirm() {
    if (!this.props.hide) {
      this.setState({ pesquisa: "" });
      if (this.props.onConfirm) {
        this.props.onConfirm(this.state.registros[this.state.index]);
      }
      this.hide();
    }
  }

  onEscape() {
    if (!this.props.hide) {
      this.setState({ pesquisa: "" });
      if (this.props.onEscape) {
        this.props.onEscape();
      }
      this.hide();
    }
  }

  onClickPaginacao(id) {
    let from = this.state.range.from;
    let to = this.state.range.to;
    if (id === "ant") {
      from -= this.state.qtderegistros;
      to -= this.state.qtderegistros;
      if (from <= 0) {
        from = 0;
        to = this.state.qtderegistros;
      }
    } else {
      from += this.state.qtderegistros;
      to += this.state.qtderegistros;
    }
    this.setState(
      {
        range: {
          from,
          to,
        },
      },
      this.carregarRegistros.bind(this)
    );
  }

  /**
   * Retorna os botões que ficarão no rodapé do modal:
   */
  getButtons() {
    return [
      {
        icon: "fa-times",
        label: "Cancelar",
        className: "btn-danger",
        onClick: () => this.hide(),
      },
      {
        icon: "fa-check",
        label: "Confirmar (F2)",
        className: "btn-success",
        onClick: this.onConfirm.bind(this),
      },
    ];
  }
  /**
   * Retorna o objeto de Api para uso no backend.
   */
  getApi() {
    if (this.props.api) {
      return this.props.api;
    }
    throw new Error("API não especificada para o componente ModalSearch!");
  }

  hide() {
    if (this.modal) {
      this.modal.hide();
    }

    document.onkeydown = null;
    this.setState({ registros: [] });
  }

  /**
   * Executa a pesquisa, filtrando os registros de acordo.
   */
  async carregarRegistros(callback) {
    GenericUtils.setElementoCarregando(this.divTable, true);
    const Api = this.getApi();

    const where = this.props.getWhere
      ? this.props.getWhere(this.state.pesquisa)
      : this.props.where
      ? this.props.where
      : "";
 
    const ret = await Api.buscar(
      this.props.tabela,
      this.state.pesquisa,
      where,
      this.state.range
    );

    if (!ret.status) {
      // TO-DO error
      GenericUtils.setElementoCarregando(this.divTable, false);
      return;
    }
    if (this.props.pagination && !this.state.filtroAplicado) {
      if (ret.dados && ret.dados.length <= 25) {
        await this.setState({
          range: {
            from: 0,
            to: 25,
          },
        });
      }
      const baseDados = [];

      for (
        let index = this.state.range.from;
        index < this.state.range.to && index < ret.dados.length;
        index++
      ) {
        baseDados.push(ret.dados[index]);
      }
      ret.dados = baseDados;
    }
    this.setState({ registros: ret.dados, index: 0 }, () => {
      GenericUtils.setElementoCarregando(this.divTable, false);
      if (typeof callback === "function") {
        callback();
      }
    });
  }

  /**
   * Seleciona um registro através do campo.
   */
  selecionarRegistroByCampo(campo, valor) {
    for (const reg of this.state.registros) {
      if (reg[campo] === valor) {
        this.setState({ itemSelecionado: reg });
        return;
      }
    }
    this.setState({ itemSelecionado: null });
  }

  /**
   * Abre esse modal.
   * @param {function} callback Callback ativado depois que carregou os registros.
   */
  async show(callback, filtro) {
    await this.setState({ pesquisa: filtro ? filtro : "" });
    document.onkeydown = (e) => {
      if (e.key === "ArrowUp" && this.state.index - 1 != -1) {
        this.input.blur();
        this.setState({ index: this.state.index - 1, focado: false });

        const scrolling = document.getElementById("tbodyId");

        scrolling.scrollTop -= 30;
      }
      if (
        e.key === "ArrowDown" &&
        this.state.index + 1 != this.state.registros.length
      ) {
        this.input.blur();
        this.setState({ index: this.state.index + 1, focado: false });

        const scrolling = document.getElementById("tbodyId");

        scrolling.scrollTop += 30;
      }
      // if (e.key === 'ArrowRight' && !this.state.focado) {
      //   this.onConfirm();
      // }
      if (e.key === "Enter" && !this.state.focado) {
        if (!this.props.desabilitaConfirmEnter) {
          this.onConfirm();
        }
      }
      if (e.key === "F2" && !this.state.focado) {
        this.onConfirm();
      }
      if (e.key === "Escape" && !this.state.focado) {
        this.hide();
      }
      if (e.key === "Escape") {
        this.onEscape();
      }
    };
    this.modal.show();
    this.carregarRegistros(callback);
    setTimeout(() => {
      if (this.input) {
        this.input.focus();
      }
    }, 500);
  }

  render() {
    return (
      <Modal
        title={this.props.titulo}
        buttons={this.getButtons()}
        ref={(e) => (this.modal = e)}
        onHide={this.props.onHide}
        closeOnEsc
        confirmOnF2={this.onConfirm.bind(this)}
        style={this.props.modalStyle ? this.props.modalStyle : null}
      >
        {this.props.botoes &&
          this.props.botoes.map((x, y) => (
            <Button
              icon={x.icone}
              label={x.label}
              className={"btn-primary " + x.className}
              onClick={(e) => x.onClick(e)}
            />
          ))}

        <InputGroup
          placeholder="Digite seu filtro"
          buttonIcon="fa-check"
          buttonLabel="Pesquisar"
          onClick={this.carregarRegistros.bind(this)}
          onBlur={() => this.setState({ focado: false })}
          onFocus={() => this.setState({ focado: true })}
          value={this.state.pesquisa}
          inputRef={(e) => (this.input = e)}
          onChange={(e) =>
            this.setState({ pesquisa: e.target.value }, () =>
              this.carregarRegistros()
            )
          }
          onKeyEnter={() => {
            if (this.props.confirmaFiltro) {
              return this.onConfirm();
            }
            this.input.blur();
            this.carregarRegistros();
          }}
        />

        <div
          className="relative"
          //  id="div_scroll"
          //  style={{ overflowY: 'scroll' }}
          ref={(e) => (this.divTable = e)}
        >
          <Table
            hideActions
            maxHeight={this.props.tableMaxHeight}
            tableStyle={this.props.tableStyle}
            selectable
            scrollable
            tbodyId={"tbodyId"}
            data={this.state.registros}
            selectedItem={
              this.state.itemSelecionado ||
              this.state.registros[this.state.index]
            }
            onSelectItem={(e) => {
              const index = this.state.registros.findIndex((x) => x == e);
              this.setState({ index, itemSelecionado: null });
            }}
            onDoubleClick={() => {
              this.onConfirm();
              if (this.modal) {
                this.modal.hide();
              }
            }}
          >
            {this.props.renderColunas()}
          </Table>
        </div>

        {this.props.pagination && (
          <div>
            <Button
              label="Pág. Anterior"
              icon="fa-arrow-left"
              className="btn-primary btn-flatx mr-10"
              onClick={this.onClickPaginacao.bind(this, "ant")}
              disabled={this.state.range.from <= 0 || this.state.filtroAplicado}
            />
            <Button
              label="Próx. Página"
              icon="fa-arrow-right"
              className="btn-primary btn-flatx"
              onClick={this.onClickPaginacao.bind(this, "prox")}
              disabled={
                this.state.registros.length < this.state.qtderegistros ||
                this.state.filtroAplicado
              }
            />
          </div>
        )}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/ModalSearch.jsx